module.exports = __webpack_public_path__ + "img/1.c016ede0.jpg";